import React from "react";
import { crudAll, defaults, ResourceDescriptor } from "./common";

import UserRoleSummary from "../components/UserRoleSummary";
import UserInfoSummary from "../components/UserInfoSummary";
import { Link } from "react-router-dom";
import DisabledDeleteResourceButton from "../components/DisabledDeleteResourceButton";
import NotSetValue from "../components/NotSetValue";

function getNotLoggedInYetLabel() {
    return <NotSetValue label="not_logged_in_yet" />;
}

const user_sub: ResourceDescriptor = {
    url: "user_subs",
    orders: {
        list: ["user_sub", "user_infos", "controlHeaderCell"],
        read: ["user_sub", "user_infos", "roles"],
        create: ["user_sub"],
    },
    crudActions: crudAll,
    listDefaults: defaults.list,
    renderers: {
        read: {
            roles: (val, row) => {
                return <UserRoleSummary userGrants={row["user_grants"]} userSubId={row.id} />;
            },
            user_infos: (val, row) => {
                // jscs: ignore requireCamelCaseOrUpperCaseIdentifiers
                return <UserInfoSummary userInfos={val} />;
            },
        },
        list: {
            user_infos: (val, row) => {
                // jscs: ignore requireCamelCaseOrUpperCaseIdentifiers
                return val.length ? val[0].name : getNotLoggedInYetLabel();
            },
            user_sub: (val, row) => {
                // jscs: ignore requireCamelCaseOrUpperCaseIdentifiers
                return <Link to={`/user_subs/read/${row.id}`}>{val}</Link>;
            },
            controlHeaderCell: (val, row) => {
                return (
                    <DisabledDeleteResourceButton
                        resourceName="user_sub"
                        id={row.id}
                        userId={row.id}
                        translationKey="deleting_own_user_is_forbidden"
                    />
                );
            },
        },
    },
    expand: {
        read: [
            "user_infos.client",
            "user_grants.role",
            "user_grants.user_contexts.context",
            "user_grants.role.client",
            "user_grants.role.role_contexts",
        ],
        list: ["user_infos"],
    },
    identifiers: ["user_infos", "user_sub"],
};

export default user_sub;
